"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UIElementStatusEnum = void 0;
let UIElementStatusEnum = exports.UIElementStatusEnum = /*#__PURE__*/function (UIElementStatusEnum) {
  UIElementStatusEnum["Success"] = "success";
  UIElementStatusEnum["Error"] = "error";
  UIElementStatusEnum["Info"] = "info";
  UIElementStatusEnum["Warning"] = "warning";
  return UIElementStatusEnum;
}({});